import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MergePurgeParameters } from './types/merge-purge-parameters.type';
import type { MultisByGroup } from './types/multis-by-group.type';

/**
 * Fetches multis by group for merge-purge reports using the provided Ky HTTP client instance and search parameters.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param searchParams - The parameters for the merge-purge operation.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array
 * of {@link MultisByGroup}.
 * @throws Throws an error if the request fails.
 */
export const getMultisByGroup = async (instance: KyInstance, searchParams: MergePurgeParameters) => {
  try {
    return await instance
      .get<OperationResultWithData<MultisByGroup[]>>(Uri.reports.mergePurge.multisByGroup, {
        searchParams,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
